export class GeLastRecordFromFarmDapUseCase {
  constructor(farmsDapRepository) {
    this.farmsDapRepository = farmsDapRepository;
  }

  async execute(ID_FARM) {
    const farm_dap = await this.farmsDapRepository.getLastRecordByIdFarm(ID_FARM)
    return farm_dap
  }
}
